
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09fa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09fa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ez1WD = parcelRequire("ez1WD");

var $isZ2V = parcelRequire("isZ2V");
class $504f3de0a6503379$export$2e2bcd8739ae039 {
    constructor(service, template){
        this.productService = service;
        this.productTemplate = template;
        this.currentParams = {};
    }
    /**
   * Initializes the ProductList instance.
   * This method renders the products initially and binds event handlers.
   */ init = async ()=>{
        await this.displayProducts();
        this.bindEventHandles();
    };
    /**
   * Fetch all products from the ProductService.
   * Render the products using the ProductTemplate component.
   */ displayProducts = async (params = {})=>{
        this.productTemplate.toggleIndicator(true);
        this.currentParams = {
            ...this.currentParams,
            ...params
        };
        const products = await this.productService.getList(this.currentParams);
        if (products) this.productTemplate.renderProducts(products);
        else {
            this.productTemplate.renderProducts();
            (0, $isZ2V.default).error((0, $ez1WD.MESSAGES).GET_PRODUCT_FAILED_MESSAGE);
        }
        this.productTemplate.toggleIndicator(false);
    };
    /**
   * Binds event handlers for managing product.
   */ bindEventHandles = ()=>{
        this.productTemplate.bindToggleModal();
        this.productTemplate.bindDeleteModalEvents(this.handleConfirmDelete);
        this.productTemplate.bindSearchProduct(this.displayProducts);
        this.productTemplate.bindSortProducts(this.displayProducts);
    };
    /**
   * Handles the confirmation of product deletion.
   * This method attempts to delete a product by its ID, renders updated products,
   * and displays success or failure messages accordingly.
   * @param {string} id - The ID of the product to be deleted.
   */ handleConfirmDelete = async (id)=>{
        const success = await this.productService.deleteByID(id);
        if (success) {
            await this.displayProducts();
            (0, $isZ2V.default).success((0, $ez1WD.MESSAGES).DELETE_PRODUCT_SUCCESS_MESSAGE);
        } else (0, $isZ2V.default).error((0, $ez1WD.MESSAGES).DELETE_PRODUCT_FAILED_MESSAGE);
        this.productTemplate.toggleDeleteModal();
    };
}



var $9St6j = parcelRequire("9St6j");

var $kALLN = parcelRequire("kALLN");

var $8XpGc = parcelRequire("8XpGc");
(function() {
    const service = new (0, $kALLN.default)();
    const template = new (0, $9St6j.default)();
    const productList = new (0, $504f3de0a6503379$export$2e2bcd8739ae039)(service, template);
    const navList = document.querySelector(".nav-list");
    // Initialize the ProductList
    productList.init();
    // Add event listener to the nav-list to handle clicks on navigation links
    navList.addEventListener("click", (0, $8XpGc.default));
})();


//# sourceMappingURL=index.179e41bc.js.map
